// Utilitaires pour le formatage des devises algériennes

/**
 * Formate un montant en Dinar Algérien (DA)
 * @param {number} amount - Le montant à formater
 * @param {boolean} showSymbol - Afficher le symbole DA
 * @returns {string} - Le montant formaté
 */
export const formatDZD = (amount, showSymbol = true) => {
  if (typeof amount !== 'number') {
    amount = parseFloat(amount) || 0;
  }
  
  // Format avec séparateurs de milliers et centimes (pour les gros montants on limite les décimales)
  const formatOptions = amount > 1000000 ? 
    { minimumFractionDigits: 0, maximumFractionDigits: 0 } : 
    { minimumFractionDigits: 2, maximumFractionDigits: 2 };
  
  const formatted = new Intl.NumberFormat('fr-DZ', formatOptions).format(amount);
  
  return showSymbol ? `${formatted} DA` : formatted;
};

/**
 * Convertit EUR vers DA (taux approximatif)
 * @param {number} eurAmount - Montant en EUR
 * @returns {number} - Montant en DA
 */
export const convertEURtoDZD = (eurAmount) => {
  const exchangeRate = 146.5; // Taux approximatif EUR/DA
  return Math.round(eurAmount * exchangeRate);
};

/**
 * Valide un numéro de téléphone algérien
 * @param {string} phone - Numéro de téléphone
 * @returns {boolean} - Valide ou non
 */
export const validateAlgerianPhone = (phone) => {
  // Format: +213 XX XX XX XX ou 0XXX XX XX XX
  const patterns = [
    /^\+213\s\d{2}\s\d{2}\s\d{2}\s\d{2}$/,
    /^0\d{3}\s\d{2}\s\d{2}\s\d{2}$/
  ];
  
  return patterns.some(pattern => pattern.test(phone));
};

/**
 * Données spécifiques à l'Algérie
 */
export const algerianData = {
  wilayas: [
    'Adrar', 'Chlef', 'Laghouat', 'Oum El Bouaghi', 'Batna', 'Béjaïa', 'Biskra',
    'Béchar', 'Blida', 'Bouira', 'Tamanrasset', 'Tébessa', 'Tlemcen', 'Tiaret',
    'Tizi Ouzou', 'Alger', 'Djelfa', 'Jijel', 'Sétif', 'Saïda', 'Skikda',
    'Sidi Bel Abbès', 'Annaba', 'Guelma', 'Constantine', 'Médéa', 'Mostaganem',
    'M\'Sila', 'Mascara', 'Ouargla', 'Oran', 'El Bayadh', 'Illizi', 'Bordj Bou Arréridj',
    'Boumerdès', 'El Tarf', 'Tindouf', 'Tissemsilt', 'El Oued', 'Khenchela',
    'Souk Ahras', 'Tipaza', 'Mila', 'Aïn Defla', 'Naâma', 'Aïn Témouchent',
    'Ghardaïa', 'Relizane', 'El M\'Ghair', 'El Meniaa', 'Ouled Djellal',
    'Bordj Badji Mokhtar', 'Béni Abbès', 'Timimoun', 'Touggourt', 'Djanet',
    'In Salah', 'In Guezzam'
  ],
  
  businessTypes: [
    'EURL', 'SARL', 'SPA', 'SNC', 'SCS', 'Entreprise individuelle'
  ],
  
  taxTypes: {
    TVA: 19, // TVA standard en Algérie
    TAP: 2,  // Taxe sur l'activité professionnelle
    VF: 1    // Versement forfaitaire
  }
}; 